import { WebPageJsonLd } from "next-seo";
import { Asset } from "~/modules/assets/types";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { getAssetURL } from "~/utils/getAssetURL";

// // // //

export function getAssetPageDescription(props: { asset: Asset }): string {
    const { asset } = props;

    return `View comprehensive analytics for ${asset.name}. Track market cap, supply metrics, and transfer stats by network, platform, issuer, and jurisdiction.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Asset Individual page using the `ArticleJsonLd` component from `next-seo`.
 *
 * @param {Object} props - The component props.
 * @param {Article} props.asset - The Asset data used to generate SEO metadata.
 */
export function AssetIndividualWebPageSEO(props: { asset: Asset }) {
    const { asset } = props;

    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(getAssetURL({ asset }))}
            description={getAssetPageDescription({ asset })}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
